import {
  CacheUpdateEvent,
  CacheDeleteEvent,
} from '@/rec-cache/rec-cache-events'

class IndexSelection {
  constructor(index, ids, refreshFn) {
    console.log(
      'rec-cache.index-selector.index-selector.constructor',
      index,
      ids
    )
    // TODO if the selection is created dynamically, ie after some individuals have been indexed, the selection is empty until query is called.
    // Rather the selection should be set to the index and the refresh function called.
    this._selection = []
    // Membership mirror of _selection. The array is what refreshFn publishes;
    // the Set is what update()/add()/delete() test against. Array.includes
    // here was O(selection) per dispatched individual, and with an empty query
    // the selection is every id in the cache.
    this._selected = new Set()
    this.index = index
    this.ids = ids
    this.text = null
    this.texts = []
    this.refreshFn = refreshFn
  }

  // TODO consider if a set rather than array shall be returned.
  get selection() {
    return this._selection
  }

  clear() {
    this._selection = []
    this._selected = new Set()
    if (this.refreshFn) this.refreshFn(this._selection)
  }

  query(text) {
    console.log('rec-cache.index-selector.state.query', text)
    if (!text) {
      this._selection = [...this.ids.values()]
      this._selected = new Set(this._selection)
      this.text = null
      this.texts = []
      if (this.refreshFn) this.refreshFn(this._selection)
      return this._selection
    }
    if (this.text == text) return this._selection

    this.texts = text
      .toLowerCase()
      .split(' ')
      .filter((w) => !!w.length)

    // Time the different parts. Use random label for timer.
    // The by far longest step is the filtering of the ids.
    // For the first letter (eg 'r') the list of ids comrpises ~16000 elementsd as duplicates is not removed until later
    // Try to create a Set with the id per string which should leave the list significantly shortetr
    // Addiitonally, if only one text is tested it shouldn bet necessary to do the logical and step with previous list

    const label = Math.random().toString(36).substring(2, 10)

    console.time(label)

    let matches = [...this.ids.values()]
    console.log('matches', matches.length)

    console.timeLog(label)
    this.texts.forEach((t) => {
      console.log('keys')
      let interim = [...this.index.keys()]
      console.timeLog(label)
      console.log('filter keys')

      interim = interim.filter((k) => k.includes(t))
      console.log('hits', interim.length)
      console.timeLog(label)
      console.log('map')

      interim = interim.map((k) => this.index.get(k))
      console.timeLog(label)
      console.log('reduce')

      const uniqueIds = new Set()
      interim.forEach((ids) => ids.forEach((id) => uniqueIds.add(id)))
      console.log('unique ids', uniqueIds.size)
      console.timeLog(label)

      // interim = interim.reduce((a, v) => a.concat(v), [])
      // console.timeLog(label)
      // console.log('filter ids', interim.length)

      matches = matches.filter((id) => uniqueIds.has(id))
      // matches = interim.filter(id => matches.includes(id))
      console.timeLog(label)

      // matches = [...this.index.keys()]
      //   .filter(k => k.includes(t))
      //   .map(k => this.index.get(k))
      //   .reduce((a, v) => a.concat(v), [])
      //   .filter(id => matches.includes(id))
    })
    console.timeLog(label)

    // TODO test for reactivity as array asignment to reactive component doesnt work...
    this._selection = [...new Set(matches)]
    this._selected = new Set(this._selection)
    // this._selection.splice(0, this._selection.length, ...new Set(matches))
    console.timeLog(label)

    if (this.refreshFn) this.refreshFn(this._selection)

    return this._selection
  }

  update(id, strings) {
    // console.log('rec-cache.index-selector.index-selection.update', id)

    // Algorithm
    // If individual already in selection and it shall be in selection, do nothing.
    // If individual not in selection, and it shall not be in selection, do nothing.
    // If individual already in selection, and it shall not be in selection, remove and refresh.
    // If individual not in selection, and it shall be in selection, add and refresh.

    const inSelection = this._selected.has(id)
    const shallBeIn =
      this.texts.filter((t) => strings.find((s) => s.includes(t))).length ==
      this.texts.length

    if (inSelection && !shallBeIn) {
      this._selection = this._selection.filter((i) => i != id)
      this._selected.delete(id)
      if (this.refreshFn) this.refreshFn(this._selection)
    }
    if (!inSelection && shallBeIn) {
      this._selection.push(id)
      this._selected.add(id)
      if (this.refreshFn) this.refreshFn(this._selection)
    }
  }

  add(id, strings) {
    if (this._selected.has(id)) return
    if (
      this.texts.filter((t) => strings.find((s) => s.includes(t))).length ==
      this.texts.length
    ) {
      this._selection.push(id)
      this._selected.add(id)
      if (this.refreshFn) this.refreshFn(this._selection)
    }
  }

  delete(id) {
    if (this._selected.has(id)) {
      this._selection = this._selection.filter((i) => i != id)
      this._selected.delete(id)
      if (this.refreshFn) this.refreshFn(this._selection)
    }
  }
}

// TODO the databases argument must be specified further. Injected from RecCache.
class IndexSelector {
  constructor(dbs) {
    console.log('rec-cache.index-selector.index-selector.constructor', dbs)

    this._states = []
    this.ids = dbs.ids
    // The index maps string to array of id values.
    // The indexed ids are a set of id values.
    this.index = new Map()
    this.indexedIds = new Set()
    // Reverse map: id -> the (deduplicated) strings it is indexed under.
    // Without it, removing an id from the index means scanning every key,
    // because there is no other way to know which posting lists mention it.
    // With ~34k keys and a re-index per individual on every sync, that scan
    // dominated sync cost. See update() below.
    this.indexedStrings = new Map()

    // TODO mount update event...
    addEventListener(CacheUpdateEvent, this.update.bind(this))
    addEventListener(CacheDeleteEvent, this.delete.bind(this))
  }

  clear() {
    this.index.clear()
    this.indexedIds.clear()
    this.indexedStrings.clear()

    this._states.forEach((s) => s.clear())
  }

  // Event handler for cache update event. Individual may be either added or updated in the cache.
  // TODO consider if the cache shall issue two different events, would likely make sense.
  // Parameter individual is a RecIndividual.
  update({ detail: individual }) {
    const id = individual.id.value
    const isUpdate = this.indexedIds.has(id)
    if (isUpdate) {
      // Remove the previous entries for this id. `indexedStrings` records
      // exactly which keys mention it — typically a handful — so only those
      // posting lists are touched. This used to walk all ~34k index keys,
      // rebuilding the whole Map for every individual, which made a resync
      // over a hydrated cache O(index size) per individual.
      this._unindex(id)
    }

    // Add values to index; the id itself, the types and the property values.
    // Only executed for values of type string, JSON literals for example, are exluded.
    // TODO may be implemented by inspecting the type of literal... ie xsd string.
    // TODO stringify non strings to ensure they are searchable too...
    const strings = [
      individual.id.value,
      ...individual.types.filter((t) => t != null).map((t) => t.value), // Filter nulls from types
      ...individual.properties
        .map((p) => p.values)
        .reduce((a, v) => a.concat(v), [])
        .filter((v) => v != null) // Filter nulls from values
        .map((v) => v.value),
    ]
      .filter((v) => typeof v == 'string')
      .map((s) => s.toLowerCase())
      .filter((s) => !!s.length)

    // console.log('rec-cache.index-selector.update.strings', strings)

    strings.forEach((s) => {
      if (this.index.has(s)) {
        this.index.get(s).push(id)
      } else {
        this.index.set(s, [id])
      }
    })

    // Record the keys so the next update/delete can undo this directly.
    // Deduplicated: a filter removes every occurrence of the id at once, so
    // one entry per distinct key is enough even when `strings` repeats a value.
    this.indexedStrings.set(id, [...new Set(strings)])
    this.indexedIds.add(id)

    this._states.forEach((s) =>
      isUpdate ? s.update(id, strings) : s.add(id, strings)
    )
  }

  // Remove every index entry for `id`, using the reverse map to touch only
  // the keys that actually mention it. Falls back to a full scan if the
  // reverse entry is missing, so the index can never be left inconsistent.
  _unindex(id) {
    const keys = this.indexedStrings.get(id)
    if (keys) {
      keys.forEach((key) => {
        const ids = this.index.get(key)
        if (!ids) return
        const remaining = ids.filter((v) => v != id)
        if (remaining.length) this.index.set(key, remaining)
        else this.index.delete(key)
      })
      this.indexedStrings.delete(id)
      return
    }

    // Fallback — should not happen, but a stale index is worse than a slow one.
    const empties = []
    this.index.forEach((ids, key) => {
      if (!ids.includes(id)) return
      const remaining = ids.filter((v) => v != id)
      if (remaining.length) this.index.set(key, remaining)
      else empties.push(key)
    })
    empties.forEach((key) => this.index.delete(key))
  }

  delete({ detail: id }) {
    this._unindex(id)

    // Remove id from indexed ids.
    this.indexedIds.delete(id)

    // Delete from selections.
    this._states.forEach((s) => s.delete(id))
  }

  // Factory for the Selection.
  // Parameter refreshFn is a function that if set is called whenever the selection changes.
  // refreshFn is called with array of ids.
  createSelection(refreshFn = null) {
    const selection = new IndexSelection(this.index, this.ids, refreshFn)
    this._states.push(selection)
    return selection
  }
}

export { IndexSelector }
